import React from 'react';
import { MapPin } from 'lucide-react';
import { NEARBY } from '../lib/butterstone';

const NearbySection = () => (
  <section id="nearby" className="section-pad bg-[#F6F5EF]" data-testid="nearby-section">
    <div className="max-w-7xl mx-auto px-5 md:px-8">
      <div className="text-center mb-12">
        <span className="overline center">Explore around</span>
        <h2 className="font-serif text-4xl md:text-6xl mt-4">Nearby places to explore</h2>
        <p className="text-[#5E6E60] mt-4 max-w-2xl mx-auto">Waterfalls, viewpoints, treks and temples — all within reach of the valley.</p>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {NEARBY.map((n, i) => (
          <div key={i} className={`group relative rounded-lg overflow-hidden h-44 ${i === 0 ? 'col-span-2 md:col-span-1 ring-2 ring-[#2F5233]' : ''}`} data-testid={`nearby-${i}`}>
            <img src={n.img} alt={n.name} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#12201a]/85 via-[#12201a]/20 to-transparent" />
            <div className="absolute left-3 right-3 bottom-3">
              <p className="text-white font-medium leading-tight">{n.name}</p>
              <p className="text-[#AFC2A4] text-[11px] tracking-wider uppercase mt-0.5">{n.type}</p>
              {n.note && <p className="text-white/80 text-[11px] mt-1 flex items-center gap-1"><MapPin size={11} /> {n.note}</p>}
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default NearbySection;
